<template>
    <div id="contenedor-main-listado">
        <template
            v-if="!$vuetify.breakpoint.xs">
            <desktop
              :listado="listado">
            </desktop>
        </template>
        <template
            v-else>
            <mobile
              :listado="listado">
            </mobile>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListado',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
